module.exports = "a.disabled {\n   color: #888;\n  pointer-events: none;\n  cursor: default;\n }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feasibility-request/feasibility-request.component.css
// module id = ./src/app/components/feasibility-request/feasibility-request.component.css
// module chunks = main